export default [
  {
    path: "/news",
    component: () => import(/* webpackChunkName: "news" */ "@/views/news/News"),
    children: [
      {
        path: "",
        name: "news",
        component: () =>
          import(/* webpackChunkName: "news" */ "@/views/news/NewsList")
      },
      {
        path: ":slug",
        name: "news-detail",
        component: () =>
          import(
            /* webpackChunkName: "news-detail" */ "@/views/news/NewsDetail"
          )
      }
    ]
  }
];
